import React, { Component } from 'react';
import { request } from 'http';

export default class StickyFooter extends Component {
	
	state ={hover:false, clicked: false, isValid: true, showAlert: false, disabeld:false, bottomOfPage:false}

	componentDidMount() {
		const cont = document.getElementById("container");
		const maxScroll = cont.scrollHeight - cont.clientHeight;
						
		
		cont.addEventListener("scroll", () => {
			const maxScroll = cont.scrollHeight - cont.clientHeight;

			if(cont.scrollTop >= maxScroll - 10){
				// console.log("bottom");
				this.setState({bottomOfPage:true})
			} else if (this.state.bottomOfPage) {
				this.setState({bottomOfPage:false});
			}
		})
	}

	scrollDown(element, maxScroll)
	{
		// element.scrollTop = 100;
		
		const duration = 200;
		const differene = 300;
		const target = (maxScroll - (element.scrollTop+differene) < 80) ? maxScroll : element.scrollTop+differene;
		const perTick = differene / duration * 10;
				
		const timer = setInterval(function(){				
			if(element.scrollTop >= target || element.scrollTop >= maxScroll-1) {
				clearInterval(timer);		
				return;
			}
			element.scrollTop += perTick;
		}, 10);
	}
	
	goNext()
	{
		this.setState({hover:false, clicked: false, isValid: true, showAlert: false, disabeld:false, bottomOfPage:false});
		global.nextStage();
	}

	render() {

		const{showFooter, isScrolling ,isValid, buttonName} = this.props;
		
		const style = {...this.props.style,
			height:80,
			display: showFooter ? "":"none",
			backgroundColor: isScrolling ? "white" : "",
			zIndex:9
		}

		const shadows = {
			normal: "0 2px 2px rgba(0, 0, 0, 0.2)", 
			hover: "0 2px 8px rgba(0, 0, 0, 0.4)",
			clicked: "0 8px 16px rgba(0, 0, 0, 0.4)"
		} ;

		if(this.state.disabeld && isValid){
			this.setState({showAlert: false, disabeld:false});			
		}

		
        return <div style={style}>
			<div style={{
				display: isScrolling ? "" : "none",
				position:"absolute",
				backgroundColor: "black",
				opacity: 0.2,
				top:1,
				width: "100%",
				height: 1,
			}}/>
			<div style={{
				position: "absolute",
				width: 200,
				height: 40,
				left: 24,
				bottom: 20,
				// backgroundColor: "rgba(255,128,128,0.2)",
				opacity: this.state.showAlert ? 1 : 0,
				transition:"all 0.3s ease-out",
			}}>
				<img src={require("../../Comp/img/baseline-error-24px.svg")}
					style={{
						position: "absolute",
						bottom: 20-12,
						color: "#D93025",						
				}}/>
				<span style={{
					fontSize: 16,
					position: "absolute",
					left: 48,
					color: "#D93025",
				}}> Please answer all questions above</span>
			</div>
        	<div style={{
				position:"absolute",
				zIndex:10,
				right: 24,
				bottom: 24,			
				padding: "8px 16px 8px 16px",
				borderRadius: 2,
				backgroundColor: this.state.clicked ? global.verylightblue : this.state.hover ? global.lightblue : global.blue,
				display:"flex",
				justifyContent:"center",
				alignItems:"center",
                cursor:"pointer",
				boxShadow: this.state.clicked ? shadows.clicked : this.state.hover ?  shadows.hover :  shadows.normal,
				pointerEvents: this.state.disabeld ? "none" : "",
				opacity: this.state.disabeld ? 0.3 : 1,
				
				transition:"all 0.2s ease-out",
				
			}} 
			onMouseEnter={() => {
				this.setState({hover:true})
			}} onMouseLeave={() => {
				this.setState({hover:false, clicked:false})
			}} onMouseDown={()=>{
				this.setState({clicked:true, hover:false})
			}} onMouseUp={()=>{
				this.setState({clicked:false, hover:false})
			}}
			onTouchCancel={() => {
				this.setState({clicked:false})
			}} onTouchStart={()=>{
				this.setState({clicked:true})
			}} onTouchEnd={()=>{			
				this.setState({clicked:false})
			}}
			onClick={()=>{
				if(isScrolling)
				{
					let cont = document.getElementById("container");
					const maxScroll = cont.scrollHeight - cont.clientHeight;
						
					if(cont.scrollTop >= maxScroll - 10){
					
						if(isValid){
							this.goNext();							
							cont.scrollTop = 0;
						} else {
							// console.log("not valid. todo: add ui alert");
							this.setState({showAlert:true, disabeld:true});							
						}
						return
					}
					
					this.scrollDown(cont, maxScroll);
					
				} else {
					if(isValid){
						this.goNext();							
					} else {
						// console.log("not valid. todo: add ui alert");
						this.setState({showAlert:true, disabeld:true});
					}					
				}
			}}>
				<span id="buttonText" style={{
					color:"white",
					fontWeight:500,
					fontSize:16,
					letterSpacing: 1.2,
					textTransform: "uppercase",
				}}>{(this.state.bottomOfPage || !isScrolling) ? buttonName : 'more'}</span>
			</div>

        </div>
    
    }
}


// WEBPACK FOOTER //
// ./src/Comp/Shared/StickyFooter.js